import { ToastrService } from 'ngx-toastr';
import {Component, OnInit} from '@angular/core';
import {IcdService} from 'src/shared/services/icd.service';

@Component({
    selector: 'app-instruction-icd10',
    templateUrl: './instruction-icd10.component.html',
    styleUrls: ['./instruction-icd10.component.scss']
})
export class InstructionIcd10Component implements OnInit {
    documents: any[] = [];
    selectedDocument: any = null;
    selectedItemId: number | null = null;

    constructor(public icdService: IcdService,private toastService:ToastrService) {
    }

    ngOnInit(): void {
        this.loadDocumentList('ICD10');
    }

    loadDocumentList(category: string) {
        this.icdService.getDocumentList(category).subscribe((data) => {
            this.documents = data.data;
            this.showDocumentDetails(this.documents[0].id)
        });
    }

    showDocumentDetails(id: number) {
        this.icdService.getDocumentDetails(id).subscribe(
            (data: any) => {
                // On successful response
                this.selectedDocument = data.data;
                this.selectedItemId = id;
            },
            (error: any) => {
                // On error
                console.error('An error occurred while fetching document details:', error);
                // Handle error here, for example, show a message to the user
                this.toastService.error(`${error?.error.error}`, 'Thất bại');

            }
        );
    }
    
}
